/**
 * Create or remplace a cookie
 * @param {*} name Name of the cookie
 * @param {*} value Value of the cookie
 * @param {*} days Valid days
 */
export function createCookie(name, value, days) {
    let expires = '';
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = '; expires=' + date.toGMTString();
    }

    const domain = '; domain=' + window.location.hostname.replace(/^([^.]+\.)?alertes-speciales\.fr$/, 'alertes-speciales.fr');
    // let domain = '; domain=localhost'; // DEV
    let secure = '';
    const sameSite = '; SameSite=Lax';

    if (window.location.protocol === 'https:') {
        secure = '; secure';
    }

    document.cookie = name + '=' + value + expires + domain + '; path=/' + secure + sameSite;
}
/**
 * Read the content of a selected cookie
 * @param {*} name Name of the cookie
 * @return {string} The value of the selected cookie
 */
export function readCookie(name) {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) {
            return c.substring(nameEQ.length, c.length);
        }
    }
    return null;
}
/**
 * Delete a cookie
 * @param {*} name Name
 */
export function eraseCookie(name) {
    // Créer une date d'expiration dans le passé
    const expirationDate = new Date();
    expirationDate.setTime(expirationDate.getTime() - 1);
    const expires = '; expires=' + expirationDate.toGMTString();

    // Déterminer le domaine actuel
    const domain = '; domain=' + window.location.hostname.replace(/^([^.]+\.)?alertes-speciales\.fr$/, 'alertes-speciales.fr');

    // Essayer de supprimer le cookie avec et sans le domaine pour s'assurer qu'il est effectivement supprimé
    document.cookie = name + '=; path=/; domain=' + domain + expires;
    document.cookie = name + '=; path=/; domain=.' + domain + expires; // Avec un point pour inclure tous les sous-domaines
    document.cookie = name + '=; path=/;' + expires; // Sans spécifier le domaine
}
